import ajax from './_ajax';
const api = {};
// SKF SSO 自动注册/登录
api.skfAutoLogin = function (params) {
  return ajax.post('/api/Sso/SkfAutoLogin', params);
};

api.getSkfSettings = function () {
  return ajax.get('/api/Sso/GetSkfSettings');
};
export default api;



// WEBPACK FOOTER //
// ./src/api/ssoApi.js